module.exports = __webpack_public_path__ + "img/icon-house-builder.dc7483e0.svg";